import React, { memo } from "react";
import { useLocation } from "react-router-dom";
import { PageTemplate } from "../../components/templates";

const Portfolios = memo((props) => {
  return (
    <PageTemplate
      title={"Portfolio"}
      subtitle={props.subtitle}
      description=""
      maxWidth={"xl"}
    >
      CONTENT
    </PageTemplate>
  );
});

Portfolios.displayName = "Portfolios";

export default Portfolios;
